import React from 'react'
import './login.css'
import FactoryVideo from './0001-0090.mkv'
import Nav from '../Nav/Nav'
import { useNavigate } from 'react-router-dom';
import loginImg from '../imgs/loginImg.png';

const Login = () => {

    const navigate=useNavigate();
    function GoHome(){
        navigate('/hero');
    }


  return(
    <>
    
    <div className="Navbar">
            <div className="Loginlogo">Property</div>
    </div>

    <div className="login">
        <div className="loginLeft">
            <img src={loginImg} />
        </div>
        <div className="loginRight">
            <div className="loginTitle">Login</div>
            <div className="Name">
                <input type="text" className='loginInput' placeholder='Enter Name'/>
            </div>
            <div className="email">
                <input type="text" className='loginInput'placeholder='Enter Email'/>
            </div>
            <div className="pswd">
                <input type="text" className='loginInput'placeholder='Enter Password'/>
            </div>
            <div className="loginButton" onClick={GoHome}>LOGIN</div>
            <div className="loginsignin" onClick={GoHome}>Aldready have an account ? Signin</div>
        </div>

    </div>
    </>
  )
  }

export default Login